function th_utterbond_layout(){
  var widget_main_html = '';
  const th_subscription_radio_fieldset = document.querySelectorAll('.th_subscription_radio_fieldset');
  const caption = document.querySelector('.wcns_subscription_default_section__') ? document.querySelector('.wcns_subscription_default_section__').getAttribute('data-caption') : '';
  const product_price = document.querySelector('.wcns_subscription_default_section__') ? document.querySelector('.wcns_subscription_default_section__').getAttribute('data-product_price') : '';
  
  if(th_subscription_radio_fieldset.length > 0){
    (th_subscription_radio_fieldset || []).forEach(function(this_item,index){

      const this_item_checkbox = this_item.querySelector('.th_subscription_radio_btn_cls_group');
      const checkbox_id = this_item_checkbox.getAttribute('id');
      let item_text =  this_item.querySelector('.th_subscription_radio_label_text');
      let mainText = item_text.childNodes[0].textContent.trim();
      let item_price =  this_item.querySelector('.th_subscription_radio_fieldset_discount_min_price').innerText;
      let item_compare_price = '';

      let discount_txt = item_text.querySelector('.th_subscription_radio_fieldset_discount_val');
      if(discount_txt){
        item_text =  mainText + ' ' + discount_txt.innerText;
      }else{
        item_text = mainText;
      }

      let is_checked = '';
      if(this_item_checkbox.checked){
        is_checked = 'checked';
      }
      let order_position = 2;
      let cpation_text = '';
      console.log("item_text", item_text);
      if(item_text.includes('ABONEAZĂ-TE ȘI ECONOMISEȘTE')){
        cpation_text = caption;
        if(item_price == ''){
          item_price =  document.querySelector('.thsb_subscription_price_update.main-price-text') ? document.querySelector('.thsb_subscription_price_update.main-price-text').innerText : '';
        }
        item_compare_price = product_price;
        order_position = 1;
      }
       widget_main_html += '<div class="utterbond-item utterbond-item-subscription" style="order:'+order_position+'" data-id="'+checkbox_id+'">';
        widget_main_html += '<input type="radio" name="utterbond-subscription" data-id="'+checkbox_id+'" class="item-utterbond-item-subscription" id="item-utterbond-item-subscription_'+index+'" '+is_checked+'/>';
        widget_main_html += '<label for="item-utterbond-item-subscription_'+index+'">';
           widget_main_html += '<span class="item-utterbond-subscripation-text">'+item_text+'<br> <span>'+cpation_text+'</span></span>';
           widget_main_html += '<div class="item_price_meta">';
              widget_main_html += '<span class="item_regular_price" style="display:none;">'+item_compare_price+'</span>';
              widget_main_html += '<span class="item_compare_price">'+item_price+'</span>';
              widget_main_html += '</div>';
        widget_main_html += '</label>';
       widget_main_html += '</div>';  
    });
  }
  return widget_main_html;
}

function th_widget__(){
    setTimeout(function(){
  let widget_main_html = '<div class="utterbond-subscription-layout-section">';
        widget_main_html += '<div class="utterbond-layout-widget">';
          widget_main_html += th_utterbond_layout();
        widget_main_html +='</div>';
      widget_main_html +='</div>';

    if(document.querySelector('.wcns_subscription_default_section .th_subscription_radio_section .thsb_subscription_description_section')){
    document.querySelector('.wcns_subscription_default_section .th_subscription_radio_section .thsb_subscription_description_section').insertAdjacentHTML("beforebegin", widget_main_html);
    // 
    if(document.querySelectorAll('.item-utterbond-item-subscription')){
      document.querySelectorAll('.item-utterbond-item-subscription').forEach(function(this_click){
        if(this_click.checked){
           this_click.closest('.utterbond-item').classList.add('is-active-item');
           // this_click.closest('.utterbond-item').querySelector('.item_compare_price').innerHTML = document.querySelector('.thsb_subscription_price_update.main-price-text') ? document.querySelector('.thsb_subscription_price_update.main-price-text').innerText : '';
        }else{
          // this_click.closest('.utterbond-item').style.order = '2';
        }
        this_click.addEventListener('change', function(){
         if(this_click.checked){
           document.querySelectorAll('.utterbond-item').forEach(function(this_val){
             this_val.classList.remove('is-active-item');
           });
           this_click.closest('.utterbond-item').classList.add('is-active-item');
         }
          const id = this_click.getAttribute('data-id');
          if(document.querySelector('.th_sp_wf_cls.th_subscription_radio_fieldset label[for="'+id+'"]')){
            document.querySelector('.th_sp_wf_cls.th_subscription_radio_fieldset label[for="'+id+'"]').click();
          }
        });
      });
    }
  }
  },1000);
}
document.addEventListener("DOMContentLoaded", function(){
  if (document.readyState !== "loading") {
    th_widget__();
  }else{
    th_widget__();
  }
});